import {
	mdiBullhornOutline,
	mdiCardAccountDetailsOutline,
	mdiFolderOutline,
	mdiHomeOutline,
	mdiPresentation,
	mdiCodeNotEqual,
	mdiStore,
	mdiCogOutline,
	mdiTrophyOutline,
} from '@mdi/js'

export default [
	{
		title: 'Home',
		icon: mdiHomeOutline,
		to: 'home',
	},
	{
		title: 'Stores',
		icon: mdiFolderOutline,
		to: 'outlets.index',
	},
	{
		title: 'Banners',
		icon: mdiPresentation,
		to: 'banners.index',
	},
	{
		title: 'Promotions',
		icon: mdiBullhornOutline,
		to: 'promotions.index',
	},
	{
		title: 'Cards',
		icon: mdiCardAccountDetailsOutline,
		to: 'cards.index',
	},
	{
		title: 'Notifications',
		icon: mdiCodeNotEqual,
		to: 'notification.index',
	},
	{
		title: 'QR Upload',
		icon: mdiCodeNotEqual,
		to: 'qr.index',
	},
	{
		title: 'Restaurants',
		icon: mdiStore,
		to: 'restaurants.index',
	},
	{
		title: 'Feedback',
		icon: mdiCodeNotEqual,
		to: 'feedback.index',
	},
	{
		title: 'Reward Points',
		icon: mdiTrophyOutline,
		to: 'points.index',
	},
	{
		title: 'Settings',
		icon: mdiCogOutline,
		to: { name: 'auth.settings.index', query: { tab: 'weekly-point' } },
	},
]

// {
// 	title: 'Feedback',
// 	icon: mdiCodeNotEqual,
// 	to: 'feedback.index',
// },
